import React, { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
import Loader from '../../_common/loader'
import BomItem from './BomItem'
import Context from 'setup/context'
import { ButtonRed } from 'styles/buttons'

const FlexCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px;
  max-height: 90vh;
  overflow-y: scroll;
`

const FlexRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding-right: 10px;
`

export default function BomItems(props) {
    const { bom, setShowAddedToCartModal, quantityAvailableToMake } = props
    const [localBom, setLocalBom] = useState([])

    const context = useContext(Context)

    useEffect(() => {
        if (bom) {
            setLocalBom(bom)
        }
    }, [bom])

    function addAllItemsToCart() {
        const items = localBom.map(item => {
            return {
                invMastUid: item.invMastUid,
                quantity: parseInt(item.quantity, 10),
            }
        })
        context.addItems(items)
        setShowAddedToCartModal(true)
    }

    function setQuantity(idx, value) {
        const newBom = JSON.parse(JSON.stringify(localBom))
        newBom[idx] = { ...newBom[idx], quantity: value }
        setLocalBom(newBom)
    }

    const bomDisplay = localBom.map((b, i) => {
        return (
            <BomItem {...{
                ...b,
                setQuantity: v => setQuantity(i, v),
                setShowAddedToCartModal,
                addItem: context.addItem,
                key: i
            }} />
        )
    })

    return (
        <>
            {bom ? (
                <div>
                    <FlexRow>
                        <h2>Bill of Materials</h2>
                        <ButtonRed onClick={addAllItemsToCart}>
                            Add Items to Cart
                        </ButtonRed>
                    </FlexRow>
                    {!!quantityAvailableToMake && (
                        <FlexRow>
                            {`Components Available To Make: ${quantityAvailableToMake}`}
                        </FlexRow>
                    )}
                    <FlexCol>
                        {bomDisplay}
                    </FlexCol>
                </div>
            ) : <Loader />}
        </>
    )
}